<template>
  <!-- 该轮播图样式为 左边为 img or video 右边为切换tab 轮播图带描述 eg: https://www.fjdynamics.com/product/autosteeringkit 轮播样式 -->

  <section class="vertical-carousel">
    <div class="pt-160 w-1200r p-r ov-h m-a">
      <h2 class="ta-c c-333 fs-48 mb-32">{{ carouselH3 }}</h2>
      <div class="desc mb-32 ta-c" v-if="carouselDesc">{{ carouselDesc }}</div>
      <!-- vertical-swiper-style:start -->
      <div class="vertical-swiper-style d-f p-r jc-sb">
        <div class="swiper-wrapper-out p-r ov-h">
          <client-only>
            <swiper class="" :options="swiperOption" ref="swiper">
              <swiper-slide v-for="(item, index) in swiperData" :key="index">
                <video
                  v-if="item.videoSrc"
                  width="100%"
                  height="100%"
                  x5-playsinline
                  x5-video-player-type="h5"
                  x-webkit-airplay="allow"
                  playsinline
                  webkit-playsinline
                  muted
                  loop
                  autoplay
                  :src="item.videoSrc"
                  :poster="item.poster"
                ></video>
                <img v-else v-lazy="item.imgSrc" width="100%" height="100%" alt="Guidance Line" />
                <div class="desc">{{ $t(item.desc) }}</div>
              </swiper-slide>
            </swiper>
          </client-only>
        </div>
        <div class="vertical-swiper-pagination p-r">
          <ul class="d-f fd-c jc-sb ul-pagination"></ul>
          <div class="line d-b p-a"></div>
        </div>
      </div>
      <!-- vertical-swiper-style:end -->
    </div>
  </section>
</template>

<script>
  export default {
    name: 'VerticalCarousel',
    props: {
      title: {
        type: String,
        default: ''
      },
      swiperOption: {
        type: Object,
        default: () => {}
      },
      swiperData: {
        type: Array,
        default: () => []
      },
      carouselH3: {
        type: String,
        default: ''
      },
      carouselDesc: {
        type: String,
        default: ''
      }
    },
    data() {
      return {}
    },
    created() {},
    mounted() {},
    methods: {}
  }
</script>

<style scoped lang="scss">
  :deep(.vertical-swiper-style .swiper-wrapper-out, .vertical-swiper-style .vertical-swiper-pagination) {
    height: 4.62rem;
  }
  :deep(.vertical-swiper-style .swiper-wrapper-out) {
    width: 8.2rem;
  }
  :deep(.vertical-swiper-style .swiper-slide) {
    width: 100%;
    height: 100%;
    position: relative;
  }
  :deep(.vertical-swiper-style .swiper-slide .desc) {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 3;
    color: #333;
    padding: 0.15rem 0.32rem;
    background-color: rgba(255, 255, 255, 0.7);
  }
  :deep(.vertical-swiper-style .vertical-swiper-pagination) {
    width: 3.35rem;
    box-sizing: border;
    border-left: 1px solid #ccc;
  }
  :deep(.vertical-swiper-style .vertical-swiper-pagination ul) {
    height: 100%;
    margin-left: 0.27rem;
    font-size: 0.2rem;
  }
  :deep(.vertical-swiper-style .vertical-swiper-pagination ul li) {
    cursor: pointer;
    outline: none !important;
    width: auto;
    height: auto;
    display: block;
    border-radius: 0;
    opacity: 1;
    background-color: transparent;
  }
  :deep(.vertical-swiper-style .vertical-swiper-pagination ul li div) {
    line-height: 0.58rem;
  }
  :deep(.vertical-swiper-style .vertical-swiper-pagination ul li .swiper-pagination-bullet-active) {
    color: #333;
    font-weight: 500;
  }
  :deep(.vertical-swiper-style .line) {
    width: 2px;
    height: auto;
    left: -1px;
    top: 0;
    background-color: #333;
    transition: transform 0.2s linear;
  }
  :deep(.swiper-pagination-bullet-active div) {
    color: #333;
    font-weight: 500;
  }
  :deep(.swiper-pagination-bullet) {
    color: #666;
    &:hover {
      color: #333;
      // font-weight: 500;
    }
  }
  :deep(.vertical-swiper-style .swiper-pagination-bullet-active)::before {
    content: ' ';
    background: #333;
    position: absolute;
    height: 0.58rem;
    left: -1px;
    width: 2px;
  }
</style>
